import React from "react";
import { Container } from "./styled";
const StatComponent = ({ data, text, comparisonValue }) => {
  const percentage =
    isNaN(Math.round((data / comparisonValue?.value) * 100)) ||
    comparisonValue === null
      ? 0
      : Math.round((data / comparisonValue?.value) * 100);

  return (
    <Container>
      <div className="progress-circle">
        <svg width="100" height="100" viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r="47"
            fill="white"
            stroke="#f3f3f3"
            strokeWidth="3"
          />

          {percentage > 0 && (
            <circle
              cx="50"
              cy="50"
              r="47"
              fill="transparent"
              stroke="red"
              strokeWidth="3"
              strokeDasharray={`${percentage * 2.95} 1000`}
              transform="rotate(-90 50 50)"
            />
          )}
        </svg>
        <div class="text">
          <h3>{isNaN(data) ? 0 : data}</h3>
        </div>
      </div>
      <p>{text}</p>
      <div className="hover-information">
        <p>
          {parseFloat(comparisonValue?.value).toFixed(1).replace(/\.0$/, "")}
        </p>
        <p>
          {`${comparisonValue?.player_name} ${comparisonValue?.player_lastname}`}
        </p>
      </div>
    </Container>
  );
};

export default StatComponent;
